import { createComponent } from '@mtfe/sweet';
import { common, eventBus, dom } from '@mtfe/sweet-utils';
import { Tabs } from '@mtfe/sweet-components';
import tpl from './dom.html';
import style from './style.less';
import store, { storeRecallBizIdMap } from '../../store/index';

const { TabsPane } = Tabs;

const { createUniqueId, isFunction, throttle } = common;

const shangouBtnID = createUniqueId();
const shangouBtnAnimationID = createUniqueId();
const tabsNavID = createUniqueId();
let isDisplayedToUser = false;

const cbFunction = throttle(() => {
    const tabsNavDom = dom.$id(tabsNavID);
    const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
    );
    const tenVWInPixels = vw * 0.2;
    const { top } = tabsNavDom.getBoundingClientRect();
    if (top <= tenVWInPixels) {
        eventBus.$emit('handleShangouTabBubble', false);
    } else {
        eventBus.$emit('handleShangouTabBubble', true);
    }
}, 200);

function waimaiModuleActive() {
    const storeWaimai = store[storeRecallBizIdMap.waimai];
    const storeShangou = store[storeRecallBizIdMap.shangou];

    const waimaiDom = dom.$id(storeWaimai.tabsContainerID);
    const shangouDom = dom.$id(storeShangou.tabsContainerID);
    const shangouBtn = dom.$id(shangouBtnID);
    const tabsNavDom = dom.$id(tabsNavID);

    tabsNavDom.classList.remove(style.tabsNavShangouActive);
    tabsNavDom.classList.add(style.tabsNavWaimaiActive);
    waimaiDom.style.display = '';

    if (shangouDom) {
        shangouDom.style.display = 'none';
        shangouBtn.classList.remove(style.rightActive);
    }
}
function shangouModuleActive() {
    const storeWaimai = store[storeRecallBizIdMap.waimai];
    const storeShangou = store[storeRecallBizIdMap.shangou];

    const waimaiDom = dom.$id(storeWaimai.tabsContainerID);
    const shangouDom = dom.$id(storeShangou.tabsContainerID);

    const shangouBtn = dom.$id(shangouBtnID);
    const tabsNavDom = dom.$id(tabsNavID);

    tabsNavDom.classList.remove(style.tabsNavWaimaiActive);
    tabsNavDom.classList.add(style.tabsNavShangouActive);
    waimaiDom.style.display = 'none';

    if (shangouDom) {
        shangouDom.style.display = '';
        shangouBtn.classList.add(style.rightActive);
    }
}

const TabReady = () => {
    eventBus.$on('TabReady', () => {
        const animationDom = dom.$id(shangouBtnAnimationID);
        const tabsNavDom = dom.$id(tabsNavID);
        if (animationDom && tabsNavDom) {
            // 执行一次，判断是否展示
            cbFunction();
            // 保证对同一个函数的应用
            window.removeEventListener('scroll', cbFunction);
            window.addEventListener('scroll', cbFunction);
        }
    });
};

const Tab = (props = {}) => {
    const storeWaimai = store[storeRecallBizIdMap.waimai];
    const storeShangou = store[storeRecallBizIdMap.shangou];
    const {
        onClickTabsCb,
        defaultActiveTab = storeWaimai.recallBizId,
        waimaiModule,
        shangouModule,
    } = props;

    const events = {
        onClickTabs: async (key) => {
            if (key === storeWaimai.recallBizId) {
                waimaiModuleActive();
            } else if (key === storeShangou.recallBizId) {
                isDisplayedToUser = true;
                shangouModuleActive();
                eventBus.$emit('handleShangouTabBubble', false);
            }
            if (isFunction(onClickTabsCb)) {
                onClickTabsCb(key);
            }
        },
    };

    const data = {
        leftTabsKey: storeWaimai.recallBizId,
        rightTabsKey: storeShangou.recallBizId,
        shangouBtnAnimationID,
        shangouBtnID,
        tabsNavID,
        leftComponent: TabsPane({
            tabContainerID: storeWaimai.tabsContainerID,
            innerComponent: waimaiModule,
            defaultDisplay: defaultActiveTab === storeWaimai.recallBizId,
        }),
        rightComponent: TabsPane({
            tabContainerID: storeShangou.tabsContainerID,
            innerComponent: shangouModule,
            defaultDisplay: defaultActiveTab === storeShangou.recallBizId,
        }),
    };
    if (defaultActiveTab === storeWaimai.recallBizId) {
        data.tabsNavClass = style.tabsNavWaimaiActive;
    } else if (defaultActiveTab === storeShangou.recallBizId) {
        data.tabsNavClass = style.tabsNavShangouActive;
        isDisplayedToUser = true;
    }
    eventBus.$onceOn('handleShangouTabBubble', (isShow) => {
        // 闪购tab气泡消失
        const animationDom = dom.$id(shangouBtnAnimationID);
        if (animationDom) {
            if (isShow && !isDisplayedToUser) {
                animationDom.style.display = 'flex';
            } else {
                animationDom.style.display = 'none';
            }
        }
    });

    TabReady();
    return createComponent(tpl, { style, data }, events);
};

export default Tab;
